import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    displayFlex: {
      display: "flex",
      maxWidth: "100%",
    },
    tabsContainer: {
      position: "relative",
      minHeight: "40px",
      minWidth: 0,
      padding: theme.spacing(2),
      border: "1px solid #EBEBEB",
      borderRadius: "6px",
      backgroundColor: theme.gray50,

      "& .MuiTabs-indicator": {
        height: 0,
      },

      "& .MuiTabs-flexContainer": {
        gap: theme.spacing(2),
      },
    },
    tab: {
      minHeight: 0,
      minWidth: 0,
      padding: theme.spacing(3, 5),
      borderRadius: "6px",
      textTransform: "none",
      fontSize: "14px",
      lineHeight: "20px",
      color: "#232529",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",

      "&.MuiTab-root.Mui-selected": {
        backgroundColor: theme.white00,
        color: "#232529",
      },
    },
    error: {
      color: theme.red500,
      marginRight: `${theme.spacing(4)} !important`,
      width: "20px",
    },
    scrollButton: {
      "& > .MuiTabs-scrollButtons ~.MuiTabs-scrollButtons": {
        left: "auto",
        right: 0,
      },
      "& .MuiTabs-scrollButtons": {
        alignItems: "center",
        display: "flex",
        opacity: 1,
        position: "absolute",
        height: "100%",
        width: "40px",
        zIndex: 1,
        top: 0,
        "&.Mui-disabled": { opacity: 0 },
      },
      "& .MuiTabs-scrollButtons:first-child": {
        background: `linear-gradient(90deg, ${theme.white500} 28.19%, rgba(255, 255, 255, 0) 92.43%)`,
        justifyContent: "flex-start",
      },
      "& .MuiTabs-scrollButtons:last-child": {
        background: `linear-gradient(270deg, ${theme.white500} 30.19%, rgba(255, 255, 255, 0))`,
        justifyContent: "flex-end",
      },
    },
    labelWrapper: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(5),
    },
  }),
);
